<template>
  <div>
    <b-dropdown
      aria-role="list"
      expanded
      append-to-body
      :close-on-click="closeOnClick"
    >
      <template #trigger>
        <div class="is-relative c-w-100">
          <p>{{ title }}</p>
          <div class="input-filter-specific c-w-100">
            <input
              v-if="selected && selected.inputNumber"
              type="text"
              class="input-number-dropdown averta-bold"
              :placeholder="`Masukan ${titleSelected}`"
              :value="formattedValue"
              @input="onInput"
            />
            <p v-else class="averta-bold">{{ titleSelected }}</p>
            <button
              v-if="selected"
              class="delete xmark-button"
              @click="clearSelected"
            />
            <a v-else class="card-header-icon p-0">
              <b-icon icon="menu-down"></b-icon>
            </a>
          </div>
        </div>
      </template>
      <div v-if="data.length > 0">
        <b-dropdown-item
          aria-role="listitem"
          v-for="(item, index) in data"
          :key="index"
          @click="handleSelectItem(item)"
        >
          <p class="averta-reguler py-1 py-sm-0">{{ item[titleItemProps] }}</p>
        </b-dropdown-item>
      </div>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  name: 'DropdownBasic',
  props: {
    title: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    titleItemProps: {
      type: String,
      default: 'title'
    },
    closeOnClick: {
      type: Boolean,
      default: true
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      selected: null,
      value: ''
    }
  },
  computed: {
    titleSelected () {
      return this.selected ? this.selected[this.titleItemProps] : this.placeholder
    },
    formattedValue () {
      return this.formatNumber(this.value)
    }
  },
  methods: {
    handleSelectItem (item) {
      this.selected = item
      this.value = ''

      if (item.inputNumber) {
        setTimeout(() => {
          document.querySelector('.input-number-dropdown').focus()
        }, 200)
        this.$emit('select', { ...item, value: '' })
      } else {
        this.$emit('select', item)
      }
    },
    clearSelected () {
      this.selected = null
      this.value = ''
      this.$emit('select', null)
    },
    formatNumber (val) {
      if (!val && val !== 0) return ''
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    parseNumber (val) {
      return parseInt(val.replace(/\./g, ''), 10) || 0
    },
    onInput (event) {
      const raw = this.parseNumber(event.target.value)
      if (!raw) {
        this.value = ''
      } else {
        this.value = raw
      }
      this.$emit('select', { ...this.selected, value: this.value })

      // Re-format input
      this.$nextTick(() => {
        event.target.value = this.formatNumber(raw)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.input-number-dropdown {
  border: none;
  outline: none;
  padding: 0 !important;
  border-radius: 0;
  width: 100%;

  &::placeholder {
    color: #b4b4b4;
    opacity: 1; /* Firefox */
  }

  &::-ms-input-placeholder { /* Edge 12 -18 */
    color: #b4b4b4;
  }
}
</style>
